export var BackgroundStyle;
(function (BackgroundStyle) {
    BackgroundStyle["AUTO"] = "AUTO";
    BackgroundStyle["COVER"] = "COVER";
    BackgroundStyle["CONTAIN"] = "CONTAIN";
    BackgroundStyle["CONTAIN_REPEAT"] = "CONTAIN_REPEAT";
})(BackgroundStyle || (BackgroundStyle = {}));
//# sourceMappingURL=background-style.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/chat/background-style.js
// module id = 919
// module chunks = 14